import { Chip, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { CriteriaText } from '../../constants';
import { CriteriaAction } from '../../features/criteria.feature';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { format } from 'date-fns';

const TrackerCriteriaResultsFilter = () => {
    const dispatch = useAppDispatch();
    const criteria = useAppSelector((state) => state.Criteria.TrackerCriteria);
    const [filters, setFilters] = useState<string[]>();
    useEffect(() => {
        const result = CriteriaText.getDescriptionByCriteria(criteria);

        setFilters(result);
    }, [criteria]);

    const handleDelete = (item: string) => {
        const criteriaProperty = CriteriaText.getCriteriaPropertyByDescription(item);

        if (!criteriaProperty) return;

        typeof criteria[criteriaProperty] === 'boolean'
            ? dispatch(CriteriaAction.SetCriteria({ ...criteria, [criteriaProperty]: false }))
            : dispatch(CriteriaAction.SetCriteria({ ...criteria, [criteriaProperty]: null }));
    };

    // determine calander selected label diplay on the regulatory tracker page
    const handleLabel = (item: string) => {
        const dateFormat = 'MMM d, yyyy';

        if (CriteriaText.criteriaDescription.EntryIntoForceBeforeDate?.includes(item) && criteria.EntryIntoForceBeforeDate) {
            return `${item}: ${format(criteria.EntryIntoForceBeforeDate, dateFormat)}`;
        }

        if (CriteriaText.criteriaDescription.EntryIntoForceAfterDate?.includes(item) && criteria.EntryIntoForceAfterDate) {
            return `${item}: ${format(criteria.EntryIntoForceAfterDate, dateFormat)}`;
        }

        if (CriteriaText.criteriaDescription.ContractAfterDate?.includes(item) && criteria.ContractAfterDate) {
            return `${item}: ${format(criteria.ContractAfterDate, dateFormat)}`;
        }

        if (CriteriaText.criteriaDescription.ContractBeforeDate?.includes(item) && criteria.ContractBeforeDate) {
            return `${item}: ${format(criteria.ContractBeforeDate, dateFormat)}`;
        }

        if (CriteriaText.criteriaDescription.KeelLayAfterDate?.includes(item) && criteria.KeelLayAfterDate) {
            return `${item}: ${format(criteria.KeelLayAfterDate, dateFormat)}`;
        }

        if (CriteriaText.criteriaDescription.KeelLayBeforeDate?.includes(item) && criteria.KeelLayBeforeDate) {
            return `${item}: ${format(criteria.KeelLayBeforeDate, dateFormat)}`;
        }

        if (CriteriaText.criteriaDescription.DeliveryAfterDate?.includes(item) && criteria.DeliveryAfterDate) {
            return `${item}: ${format(criteria.DeliveryAfterDate, dateFormat)}`;
        }

        if (CriteriaText.criteriaDescription.DeliveryBeforeDate?.includes(item) && criteria.DeliveryBeforeDate) {
            return `${item}: ${format(criteria.DeliveryBeforeDate, dateFormat)}`;
        }

        if (CriteriaText.criteriaDescription.ExpiryBeforeDate?.includes(item) && criteria.ExpiryBeforeDate) {
            return `${item}: ${format(criteria.ExpiryBeforeDate, dateFormat)}`;
        }

        if (CriteriaText.criteriaDescription.ExpiryAfterDate?.includes(item) && criteria.ExpiryAfterDate) {
            return `${item}: ${format(criteria.ExpiryAfterDate, dateFormat)}`;
        }

        if (CriteriaText.criteriaDescription.GrossTonnage?.includes(item) && criteria.GrossTonnage) {
            return `${item} ≥ ${criteria.GrossTonnage}`;
        }

        if (CriteriaText.criteriaDescription.NumberOfPassengers?.includes(item) && criteria.NumberOfPassengers) {
            return `${item} ≥ ${criteria.NumberOfPassengers}`;
        }

        if (CriteriaText.criteriaDescription.Deadweight?.includes(item) && criteria.Deadweight) {
            return `${item} ≥ ${criteria.Deadweight}`;
        }

        if (CriteriaText.criteriaDescription.LoadLineLength?.includes(item) && criteria.LoadLineLength) {
            return `${item} ≥ ${criteria.LoadLineLength}`;
        }

        if (CriteriaText.criteriaDescription.LengthOverall?.includes(item) && criteria.LengthOverall) {
            return `${item} ≥ ${criteria.LengthOverall}`;
        }

        if (CriteriaText.criteriaDescription.UserSearchQuery?.includes(item) && criteria.UserSearchQuery) {
            return `${item}: ${criteria.UserSearchQuery.length > 15 ? `${criteria.UserSearchQuery.substring(0, 15)}...` : criteria.UserSearchQuery}`;
        }

        return item;
    };

    return (
        <div style={{ width: '100%' }}>
            {filters && filters.length > 0 ? (
                <>
                    <Typography variant={'h6'}>{`${filters.length} Filters Selected `}:</Typography>
                    {filters.map((item: string) => {
                        return <Chip key={item} label={handleLabel(item)?.toString()} onDelete={() => handleDelete(item)} style={{ gap: 10, marginRight: 5, marginBottom: 5 }} />;
                    })}
                </>
            ) : (
                <>{/* No Filters */}</>
            )}
        </div>
    );
};

export default TrackerCriteriaResultsFilter;
